import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Image } from 'expo-image';
import { Text } from '../../../components/ui/AppText';
import { styles } from './styles';

const ShortCard = ({ video, onPress }) => (
  <TouchableOpacity style={styles.shortCard} activeOpacity={0.85} onPress={() => onPress?.(video)}>
    {video.thumbnailUrl ? (
      <Image source={{ uri: video.thumbnailUrl }} style={styles.shortThumb} contentFit="cover" transition={150} />
    ) : (
      <View style={[styles.shortThumb, styles.thumbPlaceholder]}>
        <Text style={styles.thumbPlaceholderIcon}>▶</Text>
      </View>
    )}
    <View style={styles.shortOverlay}>
      <Text style={styles.shortTitle} numberOfLines={2}>{video.title}</Text>
      <Text style={styles.shortMeta} numberOfLines={1}>
        {video.author.name} • {video.votesCount} ❤
      </Text>
    </View>
  </TouchableOpacity>
);

export default React.memo(ShortCard);
